import { Project } from '@/models/project'

export const MESSAGE_TYPES = {
  COMMENT: 'comment',
  PROGRESS_LOG: 'progress_log',
  INTERNAL: 'internal',
  INTERNAL_NOTE: 'internal_note'
}

export class Message {
  id: string
  type: string
  text: string
  attachments: string[]
  isEmailSent: boolean
  includeRealtor: boolean
  createdAt: Date
  updatedAt: Date
  projectId: string
  project?: Project

  attachTo: {
    name: string;
    collectionName: string;
    id: string;
  }

  from: {
    id: string;
    email: string;
    name: string;
  }

  to: {
    id: string;
    email: string;
    name: string;
  }

  constructor () {
    this.type = MESSAGE_TYPES.COMMENT
    this.text = ''
    this.createdAt = new Date()
    this.updatedAt = new Date()
    this.projectId = ''
    this.attachments = []
    this.from = {
      id: '',
      email: '',
      name: ''
    },
    this.to = {
      id: '',
      email: '',
      name: ''
    }
    this.isEmailSent = false
    this.includeRealtor = false
  }
}

export const messageConverter = {
  toFirestore: (message: Message) => {
    message.createdAt = message.createdAt ? new Date(message.createdAt) : new Date()
    message.updatedAt = new Date()
    return Object.assign({}, JSON.parse(JSON.stringify(message)))
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    
    // Ensure createdAt is always a Date object
    if (data.createdAt) {
      if (typeof data.createdAt === 'object' && data.createdAt.toDate) {
        // Firestore Timestamp
        data.createdAt = data.createdAt.toDate()
      } else if (typeof data.createdAt === 'string') {
        // ISO string
        data.createdAt = new Date(data.createdAt)
      } else if (!(data.createdAt instanceof Date)) {
        // Fallback for any other case
        data.createdAt = new Date(data.createdAt)
      }
    } else {
      data.createdAt = new Date()
    }
    
    // Ensure updatedAt is always a Date object
    if (data.updatedAt) {
      if (typeof data.updatedAt === 'object' && data.updatedAt.toDate) {
        // Firestore Timestamp
        data.updatedAt = data.updatedAt.toDate()
      } else if (typeof data.updatedAt === 'string') {
        // ISO string
        data.updatedAt = new Date(data.updatedAt)
      } else if (!(data.updatedAt instanceof Date)) {
        // Fallback for any other case
        data.updatedAt = new Date(data.updatedAt)
      }
    } else {
      data.updatedAt = new Date()
    }
    
    return Object.assign(new Message(), JSON.parse(JSON.stringify(data))) as Message
  }
}
